//@flow
import { t } from '../../core/i18n'
import moment from '../../core/moment'
import { isVimeoUrl, isYoutubeUrl } from '../mycharity/media/video-utils'

type ValidationResult = false | string
type ValidatorFn = (value: ?string, value2: ?string) => ValidationResult
type ValidatorFnRequired = (value: ?string) => ValidationResult

export const multiValidate = (validationsArray: ValidatorFn[], value: string) =>
  validationsArray.reduce((error, validate) => error || validate(value), false)

export const validateRequired: ValidatorFnRequired = value =>
  (!value || value.toString().trim() === '') &&
  t('app:forms.validation.required')

const emailRegEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const validateEmail: ValidatorFnRequired = email =>
  (!email || !emailRegEx.test(email)) && t('app:forms.validation.email')

export const validatePassword: ValidatorFnRequired = password =>
  (!password || password.length < 6 || password === 'password') &&
  t('app:forms.validation.password')

export const validateConfirmPassword: ValidatorFn = (value1, value2) =>
  value1 !== value2 && t('app:forms.validation.confirmPassword')

export const validateNumber: ValidatorFn = value =>
  isNaN(Number(value)) && t('app:forms.validation.number')

export const isEmptyUrl: string => boolean = url =>
  url === 'http://' || url === 'https://'

export const validateVideoUrl: ValidatorFn = url =>
  !isVimeoUrl(url) && !isYoutubeUrl(url) && t('app:forms.validation.invalidUrl')

export const validateDateNumeric: (
  date: Date | number | ?string
) => ValidationResult = date => {
  const dateFormat = 'MM/DD/YYYY'
  const formattedDate = moment(date, dateFormat).format(dateFormat)
  const dateToValidate = !!date && moment(new Date(date)).format(dateFormat)
  return (
    (!date ||
      !formattedDate ||
      formattedDate === 'Invalid date' ||
      formattedDate !== dateToValidate) &&
    t('app:forms.validation.date')
  )
}

export const validateTime: ValidatorFn = time => {
  const timeFormat = 'hh:mm A'
  const formattedTime = moment(time, timeFormat).format(timeFormat)
  return (
    (!time ||
      !formattedTime ||
      formattedTime === 'Invalid date' ||
      (time.toUpperCase().indexOf(' AM') === -1 &&
        time.toUpperCase().indexOf(' PM') === -1)) &&
    t('app:forms.validation.time')
  )
}

export const validatePhoneNumber: ValidatorFnRequired = phoneNumber =>
  phoneNumber
    ? (!phoneNumber.match(/\d{3}-\d{3}-\d{4}/) || phoneNumber.length !== 12) &&
      t('app:forms.validation.phoneNumber')
    : false

export const tinNumber: ValidatorFnRequired = tinNumber =>
  tinNumber
    ? (!tinNumber.match(/\d{2}-\d{7}/) || tinNumber.length !== 10) &&
      t('app:forms.validation.tinNumber')
    : false

export const accountNumber: ValidatorFnRequired = accountNumber =>
  accountNumber
    ? (isNaN(Number(accountNumber)) || accountNumber.length > 15) &&
      t('app:forms.validation.accountNumber')
    : false

export const rtnNumber: ValidatorFnRequired = rtnNumber =>
  rtnNumber
    ? (isNaN(Number(rtnNumber)) || rtnNumber.length !== 9) &&
      t('app:forms.validation.rtnNumber')
    : false

export const makeMaxLength = (
  maxLength: number
): ValidatorFnRequired => value =>
  value
    ? value.length > maxLength && t('app:forms.validation.maxLength')
    : false

export const validateZipcode: ValidatorFn = zipCode => {
  if (!zipCode) return false
  const value = Number(zipCode)
  return (
    (zipCode.toString().length !== 5 ||
      value !== parseInt(zipCode, 10) ||
      value < 0) &&
    t('app:forms.validation.zipCode')
  )
}



// WEBPACK FOOTER //
// ./src/services/validations/validations.js